module.exports = __webpack_public_path__ + "img/大图.1976dc4e.jpg";